const API_BASE_URL = 'https://4vkpvv0re3.execute-api.ap-southeast-2.amazonaws.com/v1';

class TestTemplateAPI {
  constructor() {
    this.baseUrl = `${API_BASE_URL}/test-template`;
  }
  // 获取认证头
  getAuthHeaders(idToken) {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    };
  }  // 创建新的TestTemplate
  async createTemplate(templateName, templateData, idToken, templateType = null, term = null, campusId = null) {
    try {
      const requestData = {
        templateName,
        templateData: JSON.stringify(templateData)
      };

      if (templateType) {
        requestData.templateType = templateType;
      }

      if (term !== null) {
        requestData.term = term;
      }

      if (campusId) {
        requestData.campusId = campusId;
      }

      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'create',
          data: requestData
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return {
        ...result,
        templateData: JSON.parse(result.templateData)
      };
    } catch (error) {
      console.error('Error creating template:', error);
      throw error;
    }
  }
  // 获取单个TestTemplate
  async getTemplate(templateId, idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),        body: JSON.stringify({
          operation: 'read',
          data: {
            id: templateId
          }
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return {
        ...result,
        templateData: JSON.parse(result.templateData)
      };
    } catch (error) {
      console.error('Error fetching template:', error);
      throw error;
    }
  }
  // 获取所有TestTemplates（完整数据）
  async getAllTemplates(idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),        body: JSON.stringify({
          operation: 'read',
          data: {}
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.map(template => ({
        ...template,
        templateData: JSON.parse(template.templateData)
      }));
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    }
  }

  // 获取所有TestTemplates摘要（不含完整templateData，用于列表页）
  async getAllTemplatesSummary(idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'read_summary',
          data: {}
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // Build a compatible templateData object from extracted summary fields
      return result.map(template => ({
        ...template,
        templateData: {
          templateType: template.templateType || 'mockTest',
          examDate: template.examDate,
          examName: template.examName,
        }
      }));
    } catch (error) {
      console.error('Error fetching template summaries:', error);
      throw error;
    }
  }  // 更新TestTemplate
  async updateTemplate(templateId, templateName, templateData, idToken, templateType = null, term = null, campusId = null) {
    try {
      const requestData = {
        id: templateId,
        templateName,
        templateData: JSON.stringify(templateData)
      };

      if (templateType) {
        requestData.templateType = templateType;
      }

      if (term !== null) {
        requestData.term = term;
      }

      if (campusId) {
        requestData.campusId = campusId;
      }

      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),        body: JSON.stringify({
          operation: 'update',
          data: requestData
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating template:', error);
      throw error;
    }
  }
  // 删除TestTemplate
  async deleteTemplate(templateId, idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'delete',
          data: {
            id: templateId
          }
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting template:', error);
      throw error;
    }
  }

  // 更新模板的Mock参数
  async updateMockParameters(templateId, mockParameters, idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'update',
          data: {
            id: templateId,
            mockParameters: mockParameters
          }
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating mock parameters:', error);
      throw error;
    }
  }

  // 更新模板的传统Mock参数
  async updateMockParametersTraditional(templateId, mockParametersTraditional, idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'update',
          data: {
            id: templateId,
            mockParametersTraditional: mockParametersTraditional
          }
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating traditional mock parameters:', error);
      throw error;
    }
  }

  // 更新模板的Term
  async updateTerm(templateId, term, idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'update',
          data: {
            id: templateId,
            term: term
          }
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating term:', error);
      throw error;
    }
  }

  // Get presigned URL for uploading custom assets (cover image or exam advice PDF)
  async getUploadUrl(templateId, fileType, contentType, idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'getUploadUrl',
          data: {
            templateId: templateId,
            fileType: fileType,  // 'coverImage' or 'examAdvicePdf'
            contentType: contentType
          }
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error getting upload URL:', error);
      throw error;
    }
  }

  // Upload file directly to S3 using presigned URL
  async uploadFileToS3(uploadUrl, file, contentType) {
    try {
      const response = await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': contentType
        },
        body: file
      });

      if (!response.ok) {
        throw new Error(`Upload failed! status: ${response.status}`);
      }

      return true;
    } catch (error) {
      console.error('Error uploading file to S3:', error);
      throw error;
    }
  }

  // Update template with custom asset URLs
  async updateCustomAssets(templateId, coverImageUrl, examAdvicePdfUrl, idToken) {
    try {
      const updateData = { id: templateId };

      // Only include fields that are provided (allows for partial updates and removals)
      if (coverImageUrl !== undefined) {
        updateData.coverImageUrl = coverImageUrl;
      }
      if (examAdvicePdfUrl !== undefined) {
        updateData.examAdvicePdfUrl = examAdvicePdfUrl;
      }

      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'update',
          data: updateData
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating custom assets:', error);
      throw error;
    }
  }

  // ============ 考试批次（Batch）管理 ============
  // 同一模板可复用于多次考试，用batch区分每场考试的response集合

  // 创建新批次（默认设为当前批次）
  async createBatch(templateId, name, idToken, setCurrent = true) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'create-batch',
          data: { templateId, name, setCurrent }
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error creating batch:', error);
      throw error;
    }
  }

  // 更新批次（重命名 和/或 设为当前批次）
  async updateBatch(templateId, batchId, idToken, { name, setCurrent } = {}) {
    try {
      const data = { templateId, batchId };
      if (name) data.name = name;
      if (setCurrent) data.setCurrent = true;

      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'update-batch',
          data
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating batch:', error);
      throw error;
    }
  }

  // 删除批次（后端会拒绝仍有response归属的批次）
  async deleteBatch(templateId, batchId, idToken) {
    try {
      const response = await fetch(this.baseUrl, {
        method: 'POST',
        headers: this.getAuthHeaders(idToken),
        body: JSON.stringify({
          operation: 'delete-batch',
          data: { templateId, batchId }
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting batch:', error);
      throw error;
    }
  }
}

export const testTemplateAPI = new TestTemplateAPI();
